import React from "react";
import { Stock, StockData } from "./InternalNotesResult";
import Popover from "~/common/Popover";
interface Props {
  grouping: boolean;
  stockData: StockData;
  hasKitStocks: boolean;
  kitStockType?: "OD" | "PA" | "";
}
const InternalNotesStockCount = ({
  grouping,
  stockData,
  hasKitStocks,
  kitStockType = ""
}: Props) => {
  const {
    extraLocations,
    isShrinkWrappedItem,
    hasMismatchedStockDropFlags,
    selectiveSourceRuleNotes,
    stockCounts,
    stocksContainDropYes,
    stocksContainStockYes
  } = stockData;
  const boolToStringYN = (bool: boolean) => {
    return bool ? "Y" : "N";
  };
  const renderStockTable = () => {
    const tableCellStyle = {
      fontSize: "14px !important"
    };
    const highlightedRowStyle = {
      background: "#FFFFCC"
    };
    return <table id="stockCountTable" className="table table-hover" data-testid="stockCountTable" data-sentry-component="renderStockTable" data-sentry-source-file="InternalNotesStockCount.tsx">
        <tbody>
          <tr>
            <th style={tableCellStyle} data-testid="stockCountItemNumberTitle">
              Item
            </th>
            <th style={tableCellStyle} data-testid="stockCountLocationTitle">
              Location
            </th>
            {hasKitStocks && kitStockType === "PA" && <th style={tableCellStyle} data-testid="stockCountQuantityTitle">
                Built
              </th>}
            {hasKitStocks && <th style={tableCellStyle} data-testid="kitStocksAvailableTitle">
                Available
              </th>}
            {!hasKitStocks && <th style={tableCellStyle} data-testid="stockCountQuantityTitle">
                Qty
              </th>}
            <th style={tableCellStyle} data-testid="stockCountBinTitle">
              Bin
            </th>
            {grouping && <>
                <th style={tableCellStyle} data-testid="stockCountStockTitle">
                  Stock
                </th>
                <th style={tableCellStyle} data-testid="stockCountDropTitle">
                  Drop
                </th>
              </>}
            <th style={tableCellStyle} data-testid="stockCountRulesTitle">
              Rules
            </th>
          </tr>
          {stockCounts.map(stock => <tr key={stock.location}>
              <td style={tableCellStyle} data-testid="stockCountItemNumber">
                {stock.itemNumber}
              </td>
              <td style={tableCellStyle} data-testid="stockCountLocation">
                {stock.location} - {stock.state}
              </td>
              {hasKitStocks && kitStockType === "PA" && <td style={tableCellStyle} data-testid="stockCountQuantity">
                  {stock.quantity}
                </td>}
              {hasKitStocks && <td style={tableCellStyle} data-testid="kitStocksAvailable">
                  {stock.availableKits}
                </td>}
              {!hasKitStocks && <td style={tableCellStyle} data-testid="stockCountQuantity">
                  {stock.quantity}
                </td>}
              <td style={tableCellStyle} data-testid="stockCountBin">
                {stock.bin}
              </td>
              {grouping && <>
                  <td style={tableCellStyle} data-testid="stockCountStockFlag">
                    {boolToStringYN(stock.stockFlag)}
                  </td>
                  <td style={tableCellStyle} data-testid="stockCountDropFlag">
                    {boolToStringYN(stock.dropFlag)}
                  </td>
                </>}
              <td style={tableCellStyle}>{renderSelectiveSourceRule(stock)}</td>
            </tr>)}

          {extraLocations.map(extraLocation => <tr data-stock-item-number={extraLocation.itemNumber} style={highlightedRowStyle} key={extraLocation.location}>
              <td style={tableCellStyle} data-testid="stockCountItemNumber">
                {extraLocation.itemNumber}
              </td>
              <td style={tableCellStyle} data-testid="stockCountLocation">
                {extraLocation.location}
              </td>
              <td style={tableCellStyle} data-testid="stockCountQuantity">
                {extraLocation.quantityAvailable}
              </td>
              <td style={tableCellStyle} data-testid="stockCountBin">
                {extraLocation.bin}
              </td>
              {grouping && <>
                  <td />
                  <td />
                </>}
              <td />
            </tr>)}
        </tbody>
      </table>;
  };
  const renderSelectiveSourceRule = (stock: Stock) => {
    const stockRule = selectiveSourceRuleNotes.find(rule => (stock.location === rule.warehouseLocation || stock.location === rule.warehouseNumber) && stock.itemNumber === rule.ruleItemNumber);
    if (stockRule) {
      let rulebackgroundcolor = "";
      switch (stockRule.ruleType) {
        case "D":
          rulebackgroundcolor = "#133aac";
          break;
        case "C":
          rulebackgroundcolor = "#FF9B40";
          break;
        case "X":
          rulebackgroundcolor = "#B22222";
          break;
        default:
          rulebackgroundcolor = "#C8A651";
      }
      return <div className="selective_source_rules">
          <div style={{
          cursor: "help",
          color: "white",
          padding: "3px",
          fontWeight: "bold",
          borderRadius: "10px",
          display: "inline-block",
          whiteSpace: "nowrap",
          backgroundColor: rulebackgroundcolor
        }} className={`selective_source_item rule_${stockRule.ruleType}`} title={`"${stockRule.notes}" - ${stockRule.createdBy}`}>
            <span data-testid="stockCountSelectiveSourceRule">
              {stockRule.ruleType}
            </span>
          </div>
        </div>;
    }
  };
  if (!(stocksContainStockYes || hasMismatchedStockDropFlags && stockCounts.length)) {
    return <div data-testid="stockCounts">
        <h4>{grouping ? "No grouping members are stocked" : "Not Stocked"}</h4>

        <div className="alert alert-success" data-testid="stockStatus">
          {grouping && "All members are "}
          {stocksContainDropYes ? <>
              Drop Ship: <b>Yes</b>
            </> : <>
              <b>Special Order</b> - Stock: <b>NO</b> Drop Ship: <b>NO</b>
            </>}
        </div>
      </div>;
  }
  if (stocksContainDropYes && !hasMismatchedStockDropFlags) {
    return <div className="alert alert-success" data-testid="stockCounts">
        Stockable Drop Ship Item
      </div>;
  }
  return <div data-testid="stockCounts" data-sentry-component="InternalNotesStockCount" data-sentry-source-file="InternalNotesStockCount.tsx">
      <h4 data-testid="stockCountsTableHeader">
        Stock Counts&nbsp;
        {hasKitStocks && <img src="//cdnimg.webstaurantstore.com/uploads/newwebadmin/2018/3/wrenchkit.gif" alt="kit-stock-indicator" data-testid="kit-stock-indicator" />}
        {stockCounts.length && <>
            {` | DS: ${boolToStringYN(stockCounts[0]!.dropFlag)} | `}
            <Popover triggerElement={(ref: React.RefObject<HTMLAnchorElement>) => <a href="##" ref={ref} style={{
          position: "relative",
          display: "inline-block",
          borderBottom: "1px dotted black",
          color: "black"
        }}>
                  {`Drop Ship Eligible: ${stockCounts[0]!.isDropShipEligible ? "Y" : "N"}`}
                </a>}>
              <span>
                {stockCounts[0]!.isDropShipEligible ? "Please confirm with DSS if other DS criteria is met to be able to drop ship." : "We will not be able to drop ship."}
              </span>
            </Popover>
          </>}
      </h4>
      {isShrinkWrappedItem && <div className="alert" data-testid="shrink-wrap-alert">
          This is a wrap item. If stock is at 0, but the case is available,
          Processing time may vary due to Wrap times in W.
        </div>}
      {renderStockTable()}
    </div>;
};
export default InternalNotesStockCount;